export default '/build/7facb028.jpg'